import { cn, Input, type InputProps } from '@repo/ui';
import { Search } from 'lucide-react';
import type { ReactElement } from 'react';

/** 검색칸 — 왼쪽 돋보기가 든 알약 입력(높이 40). 검색 상자(searchbox)로 읽힌다. */
export const SearchInput = ({ className, ...props }: InputProps): ReactElement => (
  <span className="relative block w-full max-w-xs">
    <Search
      aria-hidden="true"
      className="pointer-events-none absolute top-1/2 left-3.5 size-4 -translate-y-1/2 text-muted-foreground"
    />
    <Input type="search" className={cn('h-10 bg-background pl-10', className)} {...props} />
  </span>
);
